"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Are we displaying the entire original field
 *
 * For instance, if displayType is original for a table field then we are
 * displaying the entire component. If it is text,
 * circle, square, etc. then that means we are
 * only displaying an invidiual mapped cell from
 * the table or input group. Same is true for dropdown and multi-select fields.
 */
var original = 'original';

/**
 * Meant to be used as original display type but horizontal.
 * Primarily used for multi-select field right now.
 */
var horizontal = 'horizontal';

//Selector types: Used for individually mapping cells and options
var text = 'text';
var circle = 'circle';
var square = 'square';
var check = 'check';
var radio = 'radio';
var _default = exports["default"] = {
  original: original,
  horizontal: horizontal,
  text: text,
  circle: circle,
  square: square,
  check: check,
  radio: radio
};